import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompleteMedicalCareStruct } from '../../services/structs/orchestrator-patient/complete-medical-care.struct';
import { PrescriptionStatusEnum } from '../../enum/prescription-status.enum';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { PrescriptionsSuspensionCofirmModalComponent } from '../prescriptions-suspension-cofirm-modal/prescriptions-suspension-cofirm-modal.component';
import { PrescriptionMedicineStruct } from '../../services/structs/pharmacy/prescription-medicine.struct';
import { PrescriptionSolutionStruct } from '../../services/structs/pharmacy/prescription-solution.struct';

@Component({
    selector: 'app-prescriptions-suspension-modal',
    templateUrl: './prescriptions-suspension-modal.component.html',
    styleUrls: ['./prescriptions-suspension-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionsSuspensionModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionsSuspensionModalComponent>,
  ) { }

  public prescriptionStatusEnum: typeof PrescriptionStatusEnum = PrescriptionStatusEnum;

  public isLoading: boolean = true;
  public isHistory: boolean = false;

  public medicalCare: CompleteMedicalCareStruct[] = [];
  public listMedicalPrescriptionsToSuspend: PrescriptionMedicineStruct[] = [];
  public listMedicatedSolutionPrescriptionsToSuspend: PrescriptionSolutionStruct[] = [];

  public idCurrentMedicalCare: number;//if history

  ngOnInit(): void {
    if(this.data){
      this.medicalCare = this.data.medicalCare;
      this.isHistory = this.data.isHistory;
      this.idCurrentMedicalCare = this.data.idCurrentMedicalCare;
      if(this.data.listMedicalPrescriptionsToSuspend)
        this.listMedicalPrescriptionsToSuspend = this.data.listMedicalPrescriptionsToSuspend;
      if(this.data.listMedicatedSolutionPrescriptionsToSuspend)
        this.listMedicatedSolutionPrescriptionsToSuspend = this.data.listMedicatedSolutionPrescriptionsToSuspend;
    }

    this.isLoading = false;
  }

  close() {
    this.matDialogRef.close({
      listMedicalPrescriptionsToSuspend: this.listMedicalPrescriptionsToSuspend,
      listMedicatedSolutionPrescriptionsToSuspend: this.listMedicatedSolutionPrescriptionsToSuspend,
    });
  }

  cancel() {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      data: {
        isTwoButtonsModal: true,
        hasImage: true,
        title: 'Aviso',
        description: `O cancelamento da suspensão removerá as alterações feitas e esta ação é irreversível. Deseja continuar?`
      },
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm){
          this.listMedicalPrescriptionsToSuspend = [];
          this.listMedicatedSolutionPrescriptionsToSuspend = [];
          this.close();
        }
      }
    });
  }

  validateActionSuspendedPrescription(idPrescriptionMedicine: number): boolean {
    return this.listMedicalPrescriptionsToSuspend.find(x => x.prescriptionMedicine.idPrescriptionMedicine == idPrescriptionMedicine) ? true : false;
  }

  validateActionSuspendedSolutionPrescription(idPrescriptionSolution: number): boolean {
    return this.listMedicatedSolutionPrescriptionsToSuspend.find(x => x.prescriptionSolution.idPrescriptionSolution == idPrescriptionSolution) ? true : false;
  }

  messageEmptyListPrescription() : string {
    return this.isHistory ? 'Não há prescrições suspensas neste atendimento' : 'Não há prescrições em aberto para este atendimento';
  }

  openPrescriptionModal(prescription: any, isMedicatedSolution: boolean) {
    const dialogRef = this.dialog.open(PrescriptionsSuspensionCofirmModalComponent, {
      data: {
        prescription,
        isMedicatedSolution: isMedicatedSolution,
      },
      panelClass: 'prescriptions-suspension-confirm'
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (!isMedicatedSolution && result && result.medicalPrescriptionToSuspend) {
          this.listMedicalPrescriptionsToSuspend.push(result.medicalPrescriptionToSuspend);
        }
        else if (isMedicatedSolution && result && result.medicatedSolutionPrescriptionToSuspend) {
          this.listMedicatedSolutionPrescriptionsToSuspend.push(result.medicatedSolutionPrescriptionToSuspend);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
